// extracted by mini-css-extract-plugin
module.exports = {"header":"PageManager_header__3akqv","containerBg":"PageManager_containerBg__20vvW"};